import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import DriverInformation from './DriverInformation';
import Locations from './Locations';
import Summary from './Summary';
import Done from './Done';

const initialState = {
  driversLicense: '',
  driversLicenseState: '',
  firstName: '',
  lastName: '',
  locations: [],
};

const CreateDriverWizard = ({ onClose }) => {
  const [step, setStep] = useState(1);
  const [driverState, setDriverState] = useState(initialState);

  const next = () => {
    setStep(R.inc);
  };
  const prev = () => {
    setStep(R.dec);
  };
  const reset = () => {
    setStep(1);
    setDriverState(initialState);
  };

  return (
    <Drawer anchor="right" onClose={onClose} open>
      <Box height={1} width={390}>
        {step === 1 && (
          <DriverInformation
            driverState={driverState}
            next={next}
            onClose={onClose}
            setDriverState={setDriverState}
          />
        )}
        {step === 2 && (
          <Locations
            driverState={driverState}
            next={next}
            onClose={onClose}
            prev={prev}
            setDriverState={setDriverState}
          />
        )}
        {step === 3 && (
          <Summary driverState={driverState} next={next} onClose={onClose} prev={prev} />
        )}
        {step === 4 && <Done driverState={driverState} onClose={onClose} reset={reset} />}
      </Box>
    </Drawer>
  );
};

CreateDriverWizard.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default CreateDriverWizard;
